import { createFileRoute } from "@tanstack/react-router";
import { VisitPage, visitHeadEn } from "@/pages/VisitPage";

export const Route = createFileRoute("/en/visit")({
  head: visitHeadEn,
  component: VisitPage,
});
